module.exports = __webpack_public_path__ + "static/media/scalpel.367bb1a9.svg";